import locationUrl from '../../utils/locationUrl';

const getEmptyDataRedirect = (params, data, errors) => {
  if (errors && !data) return '/';
  if (!params) return false;
  if (!data) return false;

  const { data: dataArr } = data || {};

  const [dataObj] = dataArr || [];

  if (!dataObj) return '/';

  const { attributes } = dataObj || {};

  if (!attributes) return false;
  const { name } = attributes || {};
  if (!name) return '/';

  return false;
};

const getBreadcrumbsRedirect = (params, data, pathname) => {
  if (!params) return false;
  if (!data) return false;
  if (!pathname) return false;

  const { links } = data;
  const { breadcrumbs } = links || {};

  if (!breadcrumbs) return false;
  const url = locationUrl({ breadcrumbs });
  if (url !== pathname) return url;

  return false;
};

const redirects = ({ params, data: searchSeoSuburb, pathname, errors }) => {
  // const { searchSeoSuburb } = data || {};
  const redirectArray = [
    getEmptyDataRedirect(params, searchSeoSuburb, errors),
    getBreadcrumbsRedirect(params, searchSeoSuburb, pathname),
  ];

  return redirectArray.find(url => url);
};

export default redirects;
